import { IImportExcel } from "../models/excelModels";

export const INIT_IMPORT_FORM: IImportExcel = {
  file: null,
  type: ""
}